module.exports = __webpack_public_path__ + "img/547d72d.jpg";